import flex from './FlexFetch'
import {
  isMobilePlatform,
  setMobileAuthToken,
  clearMobileAuthToken,
} from '../utils/mobileAuth.js'
import { unwrapStrictData, unwrapStrictError } from './contractUtils'

const authEndpoint = '/api/1.0/auth/'

async function me(options = {}) {
  const response = await flex.flexFetch(authEndpoint + 'me', {
    credentials: 'include',
    ...options,
  })
  const payload = unwrapStrictData(await flex.handleResponse(response))
  return payload?.user ?? payload
}

async function login(auth) {
  const response = await flex.flexFetch(authEndpoint + 'login', {
    method: 'POST',
    body: JSON.stringify(auth),
    credentials: 'include',
  })

  if (response.status === 200) {
    if (isMobilePlatform()) {
      const data = unwrapStrictData(await response.json())
      if (data.token) {
        setMobileAuthToken(data.token)
      }
    }
    return { success: true }
  }

  if (response.status === 403) {
    const error = unwrapStrictError(await response.json())
    return {
      success: false,
      requiresVerification: error.details?.requiresVerification,
      error: error.message,
      message: error.details?.guidance || error.message,
    }
  }

  return { success: false }
}

async function logout() {
  if (isMobilePlatform()) {
    clearMobileAuthToken()
  }

  const response = await flex.flexFetch(authEndpoint + 'logout', {
    method: 'POST',
    credentials: 'include',
  })
  return unwrapStrictData(await flex.handleResponse(response))
}

async function refresh(refreshToken) {
  const response = await flex.flexFetch(authEndpoint + 'refresh', {
    method: 'POST',
    body: JSON.stringify(refreshToken ? { refreshToken } : {}),
    credentials: 'include',
  })
  return unwrapStrictData(await flex.handleResponse(response))
}

const ApiAuth = {
  me,
  login,
  logout,
  refresh,
}

export default ApiAuth
